import type { GraphQLExtensions } from '../types/graphql';

interface GraphQLErrorArgs {
  message: string;
  extensions: GraphQLExtensions;
}

export class GraphQLError extends Error {
  extensions: GraphQLExtensions;

  constructor({ message, extensions }: GraphQLErrorArgs) {
    super(message);

    // Setting the prototype manually, so we're able to use instanceof.
    // This is recommended approach by TypeScript for extending built-in classes:
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, GraphQLError.prototype);

    this.extensions = extensions;
  }
}
